import React from 'react';
import { PurchaseSvgIcon } from '../sprites';

function CreditCardImg({
  type = 'UNKNOWN',
  className = '',
  style = {},
  large = false
}) {
  return type && (
    <PurchaseSvgIcon
      id={ type.toLowerCase().replace(' ', '_') }
      className={ className }
      style={ style }
      size={ large ? 71 : [] }
    />
  );
}
export default CreditCardImg;
